import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { UserUpdateDtoRole } from "../../../api";

export interface UserRoleListProps {
  value?: UserUpdateDtoRole;
  onChange?: (value: UserUpdateDtoRole) => void;
}

export const UserRoleList = (props: UserRoleListProps) => {
  const { value: method, onChange } = props;

  const handleChange = (value: string) => {
    if (onChange) onChange(value as UserUpdateDtoRole);
  };

  return (
    <FormControl>
      <InputLabel id="user-role-list-label">User role</InputLabel>
      <Select labelId="user-role-list-label" label="User role" value={method || UserUpdateDtoRole.Admin} onChange={(e) => handleChange(e.target.value)}>
        {Object.keys(UserUpdateDtoRole).map((item) => {
          return (
            <MenuItem value={item} key={item}>
              {item}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
